/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class FirmwareApi {
    static getInstance() {
        if (!this.instance) this.instance = new FirmwareApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取固件列表
    async getFirmwareList (param,num,size){
        let url = `/api/v1/page/firmware/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 新增固件
    async addFirmware (formData, firmware_desc){
        let url = `/api/v1/page/firmware?firmware_desc=${firmware_desc}`
        let result = await this.getData(url,formData,'POST','multipart/form-data')
        return result
    }

    // 禁用固件
    async cancelFirmware (param, id){
        let url = `/api/v1/page/firmware/cancel/${id}`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 下载固件
    async downloadFirmware (param,file_no){
        let url = `/api/v1/page/firmware/download/${file_no}`
        let result = await this.getData(url,param,'GET')
        return result
    }


}

export {
    FirmwareApi
}